import LenisProvider from "@/components/site/LenisProvider";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import StatsBar from "@/components/site/StatsBar";
import Services from "@/components/site/Services";
import Marquee from "@/components/site/Marquee";
import CaseStudies from "@/components/site/CaseStudies";
import WhyUs from "@/components/site/WhyUs";
import Testimonials from "@/components/site/Testimonials";
import About from "@/components/site/About";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import WhatsAppFab from "@/components/site/WhatsAppFab";
import useSeo from "@/lib/useSeo";

export default function Home() {
  useSeo({
    title:
      "MSMEmoney.ai — MSME Subsidies, Arbitration & Project Funding | Haryana & Pan-India",
    description:
      "DPIIT-recognised advisory helping MSMEs across India secure government subsidies, recover delayed payments via MSMED Act arbitration, and structure project funding.",
    canonical: "https://msmemoney.ai/",
    ogTitle: "MSMEmoney.ai — MSME Subsidies · Arbitration · Project Funding",
    ogDescription:
      "Unlock government incentives, recover what you're owed, and fund what you're building. DPIIT-recognised. Advocates in-house.",
  });
  return (
    <LenisProvider>
      <main className="relative">
        <Nav />
        <Hero />
        <StatsBar />
        <Services />
        <Marquee />
        <CaseStudies />
        <WhyUs />
        <Testimonials />
        <About />
        <Contact />
        <Footer />
        <WhatsAppFab />
      </main>
    </LenisProvider>
  );
}
